module.exports = __webpack_public_path__ + "static/media/pbb1.bc9a2829.png";